/**
 * The vocabulary the policy is written in (plan §4, §5.1). These unions mirror
 * `used-vehicle-contracts`' `enum.schemas.ts` exactly, but they are declared here rather than imported:
 * the engine must stay free of zod and of the oRPC route builder so the browser can load it cheaply and
 * a unit test can call it with nothing installed but `decimal.js`.
 */
/** The five sections of the Settings → Equations page, in display order. */
export const EQUATION_GROUPS = ['AGE_VALUE', 'INSPECTION', 'COSTS', 'ACQUISITION', 'TRADE_IN'];
/**
 * Declared units (plan §5.2). The dimensional checker knows five base dimensions — `JOD km L day year`
 * — and treats `fraction`, `count` and `flag` as dimensionless flavours that differ only in how the UI
 * prints them.
 */
export const UNIT_NAMES = ['JOD', 'km', 'L', 'days', 'years', 'fraction', 'count', 'flag', 'JOD/day', 'JOD/L', 'km/year'];
export const isUnitName = (value) => typeof value === 'string' && UNIT_NAMES.includes(value);
//# sourceMappingURL=types.js.map